import { defineStore } from "pinia";

const setItem = (key: string, value: string) => localStorage.setItem(key, value);
const getItem = (key: string) => localStorage.getItem(key) || "";

export const useBannerInfo = defineStore("banner-info", {
  state: () => ({
    bannerId: "bannerReferral1",
    lastHiddenBannerId: getItem("hideFlashSaleId") || "",
    description: "",
    loading: false,
    isVisible: false,
  }),
  getters: {
    showBanner(state): boolean {
      // return this.isVisible;
      return false;
    },
  },
  actions: {
    hideBanner() {
      this.isVisible = false;
      // this.lastHiddenBannerId = this.bannerId;
      // setItem("hideFlashSaleId", this.bannerId);
    },
  },
});
